import { IAffairPub } from "@api/affair.int";
import { IGeoGroupPub } from "@api/geo-group.int";
import { Box, Button, HStack } from "@chakra-ui/react";
import { AFFAIR_KINDS, AFFAIR_KINDS_ARR, BogyoNumber } from "components/appComponents";
import { HitBogyo, HitBox, HitLineMain, HitLineSub, HitRight, HL, PaginatorBox, usePaginatorLocal } from "components/paginator";
import { GEO_GROPUS, useVVStore } from "components/store";
import { formatDateTime } from "components/utils";
import { VizvCard, VizvCardHeaderPopup, VizvMainCol } from "components/vizvComponents";
import { HUNGARY_CENTER } from "features/map/MyMap";
import { useEffect, useState } from "react";
import { MdArrowForward } from "react-icons/md";
import { Outlet, useNavigate, useParams } from "react-router";



export function VVGroup() {
	const store = useVVStore();
	const nav = useNavigate();

	const routeParams = useParams();
	const [groupItems, setGroupItems] = useState<IGeoGroupPub[]>([]);
	const [affairItems, setAffairItems] = useState<IAffairPub[]>([]);
	const [parentName, setParentName] = useState('');
	const [parent, setParent] = useState<IGeoGroupPub>();

	const isMobile = store.isMobile();
	const isDetailed = !!routeParams.affairKey || !!routeParams.userKey;
	const navRoot = '/group' + (parent ? '/region/' + parent?.groupKey : '');
	const navBack = parent ? ('/group' + (parent.parentKey ? '/region/' + parent.parentKey : '')) : '/map';
	const backName = store.groupList.find(g => g.groupKey === parent?.parentKey)?.title || 'Magyarország';


	useEffect(() => {
		let _parent = store.groupList.find(f => f.groupKey === routeParams.region);
		if (!_parent) {
			setGroupItems(store.groupList.filter(group => group.parentKey === 'hu'));
			setParent(undefined);
			setParentName('Magyarország');
			store.setMapMoveIntoView({ zoom: 8.7, center: HUNGARY_CENTER })
		} else {
			setGroupItems(store.groupList.filter(group => group.parentKey === routeParams.region));
			setParent(_parent);
			setParentName((_parent?.title || '???') + (_parent.geoGroupLevel === 'Region' && _parent.title !== 'Budapest' ? ' Megye' : ''));
			const gix = GEO_GROPUS.findIndex(g => g.geoGroup === _parent!.geoGroupLevel);
			store.setMapMoveIntoView({ zoom: GEO_GROPUS[gix].zoomIn, center: _parent.longLat });
			const allAffairs = store.affairList.filter(aff => aff.parentKey === _parent!.groupKey);
			allAffairs.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
			setAffairItems(allAffairs/*.splice(0, 5)*/);
			store.setSuggestionList([]);

		}
	}, [store.groupList, routeParams.region, store.affairList]);



	useEffect(() => {
		return () => {
			store.setSuggestionList([]);
		}
	}, []);

	const affairPainator = usePaginatorLocal({ items: affairItems });
	const groupPainator = usePaginatorLocal({ items: groupItems });

	return <>
		<VizvMainCol isTool={{ width: 400, isDetailed }} mapNavRoot={navRoot} >
			<VizvCard isTool
				{...navBack && { onBack: () => nav(navBack) }}
				isClosable
				mr={5} mt={5}
				maxHeight="calc(100vh - 4em)"
			>
				<VizvCardHeaderPopup fontSize='x-large' fontWeight='400' variant="blue" mb={2} {...parent && { mt: 0 }}>
					{parentName}
				</VizvCardHeaderPopup>
				<Box flex='1' overflowY='auto' overflowX='hidden'>

					{parent && <Box display='flex' flexDir='row' alignItems='center' justifyContent='center'
						pt={3} pb={5}
					>

						<HStack fontSize='sm' lineHeight='normal'  >

							{AFFAIR_KINDS_ARR.map(KIND => ({ KIND, sum: parent.sumInfo[`affairCount_${KIND.key}`] as number }))
								.filter(item => item.sum > 0)
								.map((item) => <BogyoNumber key={item.KIND.key}
									kind={item.KIND.key}
									count={item.sum}
									variant='number'
								/>)}
							{/*parent.sumInfo.guardCount > 0 && <>
								<Divider />
								<Box>
									{parent.sumInfo.guardCount} <Box as='span' color='primary.300' fontWeight='500'>VízVédő</Box>
								</Box></>*/}


						</HStack>
					</Box>}

					<PaginatorBox pager={affairPainator} item={affair =>
						<HitBox hit={{ affair }} >
							<HitBogyo />
							<HitRight>
								<HitLineSub><HL text={affair.user.userName} />&nbsp;/&nbsp;{formatDateTime(affair.createdAt)}</HitLineSub>
								<HitLineMain><HL text={affair.title} /></HitLineMain>
								<HitLineSub><HL text={AFFAIR_KINDS[affair.affairKind].name} /></HitLineSub>
							</HitRight>
						</HitBox>
					} />

					<PaginatorBox pager={groupPainator} item={group =>
						<HitBox hit={{ group }} >
							<HitBogyo />
							<HitRight>
								<HitLineMain>{group.title}</HitLineMain>
								<Box fontSize='small' lineHeight='normal' color='#fffa'>{group.sumInfo.affairCount} Eset</Box>
								{group.sumInfo.guardCount > 0 && <Box fontSize='small' lineHeight='normal' color='#fffa'>{group.sumInfo.guardCount} Vízőr</Box>}

							</HitRight>
						</HitBox>
					} />

					{/*groupItems.map((group) =>
						<NavMainLink to={`/group/region/${group.groupKey}`} key={group.groupKey}

							//px={3} py={1} 
							mb={3} gap={2}
						>
							<Icon as={FaCity} fontSize='xx-large' color='#6abadb' />
							<Box					>
								<Box fontWeight='500' textDecor='xunderline'>{group.title}</Box>

							</Box>
						</NavMainLink>)*/}
				</Box>

				{(isMobile) && <>
					<Box display='flex' mt={0} mb={1} px={1} w='100%' justifyContent='space-between'>
						<Button onClick={() => store.setLayoutPush('menu_and_tools')}
							variant='link'
							ml='auto'
							color='#fff'
							size='sm' borderRadius={0} fontWeight='400'
							rightIcon={<MdArrowForward />} >Nagyobb térkép</Button>
					</Box>
				</>}

			</VizvCard>

		</VizvMainCol>
		<Outlet />
	</>
}



